<template>
    <div
        class="VContainer"
        :style=" {
            color: 'red',
            left: `${position.left}px`,
            top: `${position.top}px`,
          }"
    >
    </div>
</template>

<script>
    import defaultSettings from './VContainer/defaultSettings';
    
    export default {
        name: 'VContainer',
        props: {
            settings: {
                type: Object,
                default: () => {
                },
            },
            event: {
                type: MouseEvent,
                required: true,
            },
        },
        data() {
            return {
                defaultSettings,
                mergedSettings: {},
                position: {
                    left: 0,
                    top: 0,
                },
            };
        },
        created() {
            this.mergedSettings = Object.assign(this.defaultSettings, this.settings);
            this.position.left = event.clientX + this.mergedSettings.position.left;
            this.position.top = event.clientY + this.mergedSettings.position.top;
        },
        watch: {
            settings: {
                deep: true,
                immediate: true,
                handler() {
                    // this.mergedSettings = Object.assign(this.defaultSettings, this.settings);
                },
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VContainer {
        position: absolute;
    }
</style>